<template>
  <div ref="wrapper" class="flex-1" v-bind="$attrs">
    <div class="h-full w-full max-w-100 min-h-[10rem]">
      <!-- Show the placeholder as background -->
      <blurhash-img
        v-if="blurhash"
        :hash="blurhash"
        :aspect-ratio="height / width"
        class="transition-opacity duration-500"
        :class="blurhashOpacity"
      />

      <!-- Show the real image on the top and fade in after loading -->
      <img
        ref="image"
        class="transition-opacity duration-500 object-cover mx-auto h-full"
        :class="imageOpacity, roundedImg, fillContainerSpace"
        alt=""
        src=""
        loading="lazy"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import BlurhashImg from "./BlurhashImg.vue";

import { computed, ref, watchEffect } from "vue";

const props = withDefaults(
  defineProps<{
    src: string;
    blurhash?: string | null;
    width?: number;
    height?: number;
    rounded?: boolean;
    fillSpace?: boolean;
  }>(),
  { blurhash: null, width: 100, height: 100, rounded: false, fillSpace: false, }
);

const isLoaded = ref(false);

const wrapper = ref<HTMLElement | null>(null);
const image = ref<HTMLImageElement | null>(null);

const src = computed(() => props.src);

const blurhashOpacity = computed(() =>
  isLoaded.value ? "opacity-0 hidden" : "opacity-100"
);

const imageOpacity = computed(() =>
  isLoaded.value ? "opacity-100" : "opacity-0"
);

const roundedImg = computed(() =>
  props.rounded ? "rounded-lg": ""
);

const fillContainerSpace = computed(() =>
  props.fillSpace ? "w-full": ""
);

watchEffect(() => {
  // Image is visible (means: has entered the viewport),
  // so start loading by setting the src attribute
  if (image.value) {
    image.value.src = src.value;

    image.value.onload = () => {
      // Image is loaded, so start fading in
      isLoaded.value = true;
    };
  }
});

</script>
